

export class UsuarioModel {

  given_name: string;
  family_name: string;
  name: string;
  preferred_username: string;
  groups: Array<string>;

}
